module.exports = __webpack_public_path__ + "static/media/humphrey-muleba.c8a3ca49.jpg";